module.exports = __webpack_public_path__ + "static/img/TRINE_ELLITSGAARD.298119d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/TRINE_ELLITSGAARD.jpg
// module id = DSe6
// module chunks = 1